
import Vue, { PropType } from 'vue'

import LogDateGroupTimeline from '@/ui/components/timeline/LogDateGroupTimeline.vue'
import Plant from '@/models/Plant'
import LogItem, { LogItemCategory } from '@/models/LogItem'
import Harvest from '@/models/Harvest'
import Image from '@/models/Image'

import { differenceInCalendarDays } from 'date-fns'

export default Vue.extend({
  components: {
    LogDateGroupTimeline,
  },
  props: {
    plant: Object as PropType<Plant>,
    category: String,
  },
  data: () => ({
    // categoryFilter: [],
  }),
  computed: {
    mergedLog(): Array<LogItem> {
      const items = [
        ...this.plant.log,
        ...this.plant.harvests.map((h: Harvest) => LogItem.fromHarvest(h)),
        ...this.plant.images.map((i: Image) => LogItem.fromImage(i)),
      ]

      if (this.plant.startDate) {
        items.push(
          new LogItem({
            id: `${this.plant.id}/start-date`,
            date: this.plant.startDate,
            category: LogItemCategory.Timeline,
            type: 'start date',
            gardenId: this.plant.gardenId,
            refs: [`garden/${this.plant.gardenId}`, `plant/${this.plant.id}`],
          })
        )
      }

      if (this.plant.endDate) {
        items.push(
          new LogItem({
            id: `${this.plant.id}/end-date`,
            date: this.plant.endDate,
            category: LogItemCategory.Timeline,
            type: 'end date',
            gardenId: this.plant.gardenId,
            refs: [`garden/${this.plant.gardenId}`, `plant/${this.plant.id}`],
          })
        )
      } else {
        items.push(
          new LogItem({
            id: `today/${this.plant.id}`,
            date: new Date().toISOString().split('T')[0], // today in dateOnly format
            category: LogItemCategory.Timeline,
            type: 'today',
            // note: 'Harvested (placeholder)',
            gardenId: this.plant.gardenId,
            refs: [`garden/${this.plant.gardenId}`, `plant/${this.plant.id}`],
          })
        )
      }

      return items
    },
    calcDayNumber(): (date: string) => number {
      if (!this.plant.startDate) return () => 0
      const startDate = new Date(this.plant.startDate)
      return (date: string) =>
        differenceInCalendarDays(new Date(date), startDate) + 1 // +1 to include the start date
    },
    // categories() {
    //   // return [...new Set(this.logItems.map(li => li.category))]
    //   return [...new Set(this.plant.log.map(l => l.category))]
    // },
    // logItems() {
    //   // return (this.category ? this.plant[this.category + 's'] : this.plant.log)
    //   return this.plant.log
    //     .filter(l =>
    //       this.category
    //         ? l.category === this.category
    //         : (this.categoryFilter.length < 1 || this.categoryFilter.includes(l.category)))
    //     .sort((a, b) => {
    //       return a.date < b.date
    //         ? 1
    //         : a.date > b.date
    //           ? -1
    //           : (b.createdAt ? b.createdAt.getTime() : Date.now()) - (a.createdAt ? a.createdAt.getTime() : Date.now())
    //     })
    // },
  },
  methods: {
    // getCategoryIcon(item) {
    //   return item.category === 'action' && item.type === 'water'
    //     ? '$water'
    //     : '$' + item.category
    // },
  },
})
